import { KeyboardBackspace as BackIcon } from '@mui/icons-material';
import React from 'react';
import * as S from './styles';

type GoBackButtonProps = {
  onClick?: () => void;
  children?: React.ReactNode;
};

const GoBackButton: React.FC<GoBackButtonProps> = ({ children, onClick }) => (
  <S.Button onPress={onClick} startAdornment={<BackIcon />}>
    {children}
  </S.Button>
);

export default GoBackButton;
